import { faCircleCheck, faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from '@redux';
import { getAllOrderHistories } from '@redux/orderHistories/actions';
import { confirmOrder, getByIdOrders } from '@redux/orders/actions';
import { Button, Col, Form, Modal, Row, Space } from 'antd';
import { RestInputContext } from 'components/form/RestInputContext';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';
import CancelModal from './CancelModal';
import FormSelect from 'components/form/FormSelect';

const { confirm } = Modal;

const OrderDetailAction = ({ data }: { data: DynamicObjectType }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const loading = useSelector((state) => state.orders.loading);

  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [cancelVisible, setCancelVisible] = useState(false);

  const CHECK_LIST = [
    {
      text: 'orders.enoughStock',
      key: 'enoughStock',
      isPassed: data?.hasStockAvailable,
    },
    {
      text: 'orders.lessThan2Mil',
      key: 'lessThan2Mil',
      isPassed: !data?.isTotalMoreThan2m,
    },
    {
      text: 'orders.noStockTransfer',
      key: 'noStockTransfer',
      isPassed: !data?.hasTransferOrder,
    },
    {
      text: 'orders.isSpamIn24h',
      key: 'isSpamIn24h',
      isPassed: !data?.isSpamIn24h,
    },
    {
      text: 'orders.isCustomerInBlackList',
      key: 'isCustomerInBlackList',
      isPassed: !data?.isCustomerInBlackList,
    },
    {
      text: 'orders.isDiscountMoreThan70',
      key: 'isDiscountMoreThan70',
      isPassed: !data?.isDiscountMoreThan70,
    },
    {
      text: 'orders.isMarketPlaceConfirmed',
      key: 'isMarketPlaceConfirmed',
      isPassed: data?.isMarketPlaceConfirmed,
      hidden: !data?.isMarketPlace,
    },
  ];

  const handleSubmit = (values) => {
    setConfirmLoading(true);
    dispatch(
      confirmOrder({
        data: {
          id: data?.id,
          data: values,
        },
        options: {
          isShowSuccessNoti: true,
        },
      }),
    )
      .then(() => {
        dispatch(
          getByIdOrders({
            data: {
              id: data?.id,
            },
            options: { isRequestApi: true, isRefresh: true },
          }),
        )
          .then(() => {
            setConfirmLoading(false);
          })
          .catch(() => {
            setConfirmLoading(false);
          });
        dispatch(
          getAllOrderHistories({
            data: {
              pageSize: 100,
              join: ['creator'],
              filters: [
                {
                  condition: 'and',
                  key: 'orderId',
                  value: data?.id,
                  operator: 'eq',
                },
              ],
              orderBy: '-createdAt',
            },
            options: {
              isRefresh: true,
            },
          }),
        );
        setVisible(false);
      })
      .catch(() => {
        setConfirmLoading(false);
      });
  };

  const action = () => {
    if (!data?.customerOrderId && data?.statusOms !== 'CANCELLED') {
      return (
        // <Row gutter={[10, 10]} className="mt-10">
        //   <Col md={6} xs={24} sm={24}></Col>
        //   <Col md={6} xs={24} sm={24}></Col>
        //   <Col md={6} xs={24} sm={24}>
        //     <Button className="w-full" onClick={() => setCancelVisible(true)}>
        //       {t('button.cancel')}
        //     </Button>
        //   </Col>
        //   <Col md={6} xs={24} sm={24}>
        // <Button
        //   className="w-full"
        //   loading={confirmLoading}
        //   onClick={() => {
        //     confirm({
        //       title: t('orderDetail.confirmOrder'),
        //       content: !CHECK_LIST[0]?.isPassed ? (
        //         <div className="txt-error">
        //           {t('orderDetail.warningOutOffStock')}
        //         </div>
        //       ) : (
        //         ''
        //       ),
        //       okText: t('button.ok'),
        //       cancelText: t('button.cancel'),
        //       onOk: () => {
        //         // if (data?.locationId && data?.partnerId) {
        //         //   handleSubmit({
        //         //     storeId: data?.locationId,
        //         //     partnerId: data?.partnerId,
        //         //   });
        //         // } else if (data?.locationId || data?.partnerId) {
        //         //   form.setFieldsValue({
        //         //     storeId: data?.locationId,
        //         //     partnerId: data?.partnerId,
        //         //   });
        //         //   setVisible(true);
        //         // }
        //         handleSubmit({
        //           storeId: data?.locationId,
        //           partnerId: data?.partnerId,
        //         });
        //       },
        //       onCancel: () => {},
        //     });
        //   }}
        //   type="primary"
        // >
        //   {t('orderDetail.approve')}
        // </Button>
        //   </Col>
        // </Row>
        <div className="flex mt-10 gap-2.5 justify-end">
          <Button onClick={() => setCancelVisible(true)}>
            {t('button.cancel')}
          </Button>
          <Button
            loading={confirmLoading}
            onClick={() => {
              confirm({
                title: t('orderDetail.confirmOrder'),
                content: !CHECK_LIST[0]?.isPassed ? (
                  <div className="txt-error">
                    {t('orderDetail.warningOutOffStock')}
                  </div>
                ) : (
                  ''
                ),
                okText: t('button.ok'),
                cancelText: t('button.cancel'),
                onOk: () => {
                  // if (data?.locationId && data?.partnerId) {
                  //   handleSubmit({
                  //     storeId: data?.locationId,
                  //     partnerId: data?.partnerId,
                  //   });
                  // } else if (data?.locationId || data?.partnerId) {
                  //   form.setFieldsValue({
                  //     storeId: data?.locationId,
                  //     partnerId: data?.partnerId,
                  //   });
                  //   setVisible(true);
                  // }
                  handleSubmit({
                    storeId: data?.locationId,
                    partnerId: data?.partnerId,
                  });
                },
                onCancel: () => {},
              });
            }}
            type="primary"
          >
            {t('orderDetail.approve')}
          </Button>
        </div>
      );
    }
    return <div />;
  };
  return (
    <>
      <CancelModal
        visible={cancelVisible}
        onCancel={() => setCancelVisible(false)}
        {...data}
      />
      <Space size={10} direction="vertical">
        {CHECK_LIST.filter((i) => !i?.hidden)?.map((e) => (
          <Space size={12} className="align-center" key={e.key}>
            {e.isPassed ? (
              <FontAwesomeIcon
                icon={faCircleCheck}
                style={{
                  color: '#88C041',
                  width: 20,
                  height: 20,
                  display: 'flex',
                  alignItems: 'center',
                }}
              />
            ) : (
              <FontAwesomeIcon
                icon={faCircleXmark}
                style={{
                  color: '#E20000',
                  width: 20,
                  height: 20,
                  display: 'flex',
                  alignItems: 'center',
                }}
              />
            )}
            <div>{t(e.text)}</div>
          </Space>
        ))}
      </Space>
      {action()}
      <Modal
        title={t('orderDetail.logistics')}
        open={visible}
        onCancel={() => setVisible(false)}
        okText={t('logistics.createOrder')}
        width={700}
        okButtonProps={{
          loading,
        }}
        onOk={() => {
          form.submit();
        }}
      >
        <RestInputContext.Provider value={{ form }}>
          <Form layout="vertical" form={form} onFinish={handleSubmit}>
            <Row gutter={[16, 16]}>
              <Col md={24}>
                {/* <RestInputItem isReference source="storeId">
                  <RestReferenceInput
                    defaultOptions={{
                      customApiResource: `locations/delivery/${data?.chainStoreId}`,
                    }}
                    resource="locations"
                  >
                    <RestSelect
                      header="orders.stores"
                      required
                      titleProp="name"
                      valueProp="id"
                      formatText={(name, record) => (
                        <div>
                          <div className="semi-bold">
                            {name ? `${name} | ${record?.id}` : record?.id}
                          </div>
                        </div>
                      )}
                    />
                  </RestReferenceInput>
                </RestInputItem> */}
                {/* <FormItem name="locations"></FormItem> */}
                <FormSelect
                  reference={{
                    labelProp: 'name',
                    model: `locations`,
                    // /delivery/${data?.chainStoreId}`,
                    searchKey: 'name',
                    valueProp: 'id',
                    allowClear: true,
                    labelFormat: (item) => (
                      <div>
                        {item?.name ? `${item?.name} | ${item?.id}` : item?.id}
                      </div>
                    ),
                  }}
                  name="storeId"
                  label={t('orders.stores')}
                  required
                />
              </Col>
              <Col md={24}>
                {/* <RestInputItem isReference source="partnerId">
                  <RestReferenceInput
                    resource="partners"
                    initialFilter={{
                      filter: {
                        isDelivery: true,
                      },
                    }}
                  >
                    <RestSelect
                      header="orders.partner"
                      titleProp="name"
                      valueProp="id"
                      required
                      formatText={(name, e) => (
                        <div>
                          <div className="semi-bold">{`${name} - ${e.id}`}</div>
                        </div>
                      )}
                    />
                  </RestReferenceInput>
                </RestInputItem> */}
                <FormSelect
                  reference={{
                    labelProp: 'name',
                    model: `partners`,
                    searchKey: 'name',
                    valueProp: 'id',
                    allowClear: true,
                    labelFormat: (item) => (
                      <div>{`${item?.name} - ${item?.id}`}</div>
                    ),
                    initFilters: {
                      filters: [
                        {
                          condition: 'and',
                          key: 'isDelivery',
                          operator: 'eq',
                          value: true,
                        },
                      ],
                    },
                  }}
                  name="partnerId"
                  label={t('orders.partner')}
                  required
                />
              </Col>
            </Row>
          </Form>
        </RestInputContext.Provider>
      </Modal>
    </>
  );
};

export default OrderDetailAction;
